// material
import { styled } from '@mui/material/styles';
import { useEffect } from 'react';
import { Divider } from '@mui/material';
// components
import Page from '../components/Page';
import {
  AboutHero,
  AboutWhat,
  AboutTeam,
  AboutVision,
  AboutTestimonials
} from '../components/_external-pages/about';
import ContactFloatingButton from 'layouts/main/ContactFloatingButton';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  paddingTop: theme.spacing(8),
  width: '100%',
  height: '100vh',
  [theme.breakpoints.up('md')]: {
    paddingTop: theme.spacing(11)
  }
}));

// ----------------------------------------------------------------------

export default function Swagger() {
  let swaggerURL = 'http://localhost:5000';
  if (window.location.hostname?.includes('tradingtown.space')) {
    swaggerURL = 'https://api.tradingtown.space';
  }
  return (
    <RootStyle title="API Document">
      <iframe
        src={`${swaggerURL}/docs`}
        style={{ width: '100%', height: '100%', border: 0, overflow: 'visible' }}
      ></iframe>
    </RootStyle>
  );
}
